import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { useGetTenantQuery, useGetTenantsQuery, useUpdateTenantConfigMutation } from "../tenantSlice";
import { useParams } from "react-router-dom";
import { Button, Dialog,Grid, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Switch, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { tenantFeatureFlagLabels, tenantFeatureFlagNames,tenantDispatchLabels, tenantDispatchNames } from "../TenantConfig/tenantConfigConsts";
import { IconSettings } from "icons";
import NotificationProvider from "components/NotificationProvider";
import CustomInput from "components/CustomInput";

const TenantConfigDialog = ({ id }) => {
    const routeParams = useParams();
    let { data: tenant, error, isLoading } = useGetTenantQuery(id ?? routeParams?.id);
    let [updateTenantConfig, { isLoading: isSaving }] = useUpdateTenantConfigMutation();
    const [featureFlags, setFeatureFlags] = useState({});
    const [dispatchValues, setDispatchValues] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [changed, setChanged] = useState(false);

    const onConfigChange = (flagName, value) => {
        setFeatureFlags((prevFlags) => ({
            ...prevFlags,
            [flagName]: value
        }));
        setChanged(true);
    };

    const onDispatchConfigChange = (name, value) => {
        debugger;   
        setDispatchValues((prev) => ({
            ...prev,
            [name]: value
        }));
        setChanged(true);
    };

    const onSave = async () => {
        const res = await updateTenantConfig({
            tenantId: id,
            tenantFeatureFlags: featureFlags,
            tenantDispatchInformation: dispatchValues
        });
        if (res.error) {
            NotificationProvider.error(`Failed to save tenant: ${res.error?.data?.messages?.join(" ")}`);
        } else {
            NotificationProvider.success("Saved tenant successfully");
            setDialogOpen(false);
        }
    }


    useEffect(() => {
        setFeatureFlags(tenant?.config?.tenantFeatureFlags)
        setDispatchValues(tenant?.config?.tenantDispatchInformation)
        setChanged(false);
    }, [tenant]);

    return (<Authorize profile={permissionProfiles.SAAS_MANAGEMENT.MANAGE_TENANTS}>
        <IconButton
            onClick={() => setDialogOpen(true)}>
            <IconSettings />
        </IconButton>
        <Dialog
            open={dialogOpen}
            onClose={() => { }}
            fullWidth
            maxWidth='md'>
            <DialogTitle>Configure Tenant {tenant?.name}</DialogTitle>
            <DialogContent>

                {Object.values(tenantFeatureFlagNames).map((flagName) =>
                    <div key={flagName}>
                        <FormControlLabel
                            control={
                                <Switch
                                    color="primary"
                                    checked={featureFlags?.[flagName]}
                                    onChange={(e) => onConfigChange(flagName, e.target.checked)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                            label={
                                <div>{tenantFeatureFlagLabels?.[flagName] ?? flagName}</div>
                            }
                        />
                    </div>
                )}
                <br/>
                <Grid container direction="column" spacing={2}>
                 {  Object.values(tenantDispatchNames).map((name) =>
                    <Grid item key={name} sx={{ marginTop: 2 }}>

                        <CustomInput
                            label={tenantDispatchLabels?.[name] ?? name}
                            color="primary"
                            value={dispatchValues?.[name]}
                            onChange={(val) => onDispatchConfigChange(name, val)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </Grid>
                )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => setDialogOpen(false)}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={onSave}
                    disabled={!changed || isSaving}
                >
                    {isSaving ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    </Authorize>)
}

export default TenantConfigDialog;